import { render } from "./Inmueble.vue?vue&type=template&id=776c3163&scoped=true"
import script from "./Inmueble.vue?vue&type=script&lang=js"
export * from "./Inmueble.vue?vue&type=script&lang=js"

import "./Inmueble.vue?vue&type=style&index=0&id=776c3163&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-776c3163"]])

export default __exports__